import { memo as Memo } from 'react'

//* HOC
import withLanguageContext from 'context/consumerHOC/LanguageConsumer'

//* Components
import Container from 'components/common/Container'
import Button from 'components/common/Button'
import Text from 'components/common/Text'
import Image from 'components/common/Image'

//* Style
import HeroSectionStyle from './style'

const Hero = Memo(({ url, name, text, time, tools, glass, garnish, methods, occasion, image, difficulty, ingredients, translate }) => {
	return (
		<HeroSectionStyle className='white-bg'>
			<Container>
				<Button
					url={url}
					className='phs-back-btn'
					btnType='with-lottie'
					text={'backToCocktails'}
				/>
			</Container>

			<Container
				row
				className={`cocktail-hero-section phs-cont`}
			>
				<div className='col-6 col-ts-12 phs-image-col cocktail-hero-image'>
					<div className='phs-image-cont'>
						<Image
							src={image?.src}
							alt={image?.alt}
						/>
					</div>
				</div>

				<div className='col-4 col-ds-5 col-t-6 col-ts-12 phs-info-col cocktail-hero-info'>
					<div className={`cocktail-internal phs-info-cont primary-color9`}>
						<Text
							tag={`h1`}
							className={`h5 minion3-medium primary-color9 uppercase`}
							text={name}
						/>

						{text ? (
							<Text
								tag={`p`}
								className={`p p4 notoSans-regular primary-color9 cocktail-hero-text`}
								text={text}
							/>
						) : (
							''
						)}

						<div className={`cocktail-banner`}>
							{difficulty ? (
								<div className={`banner-item`}>
									<Text
										tag={`p`}
										className={`p p4 notoSans-regular primary-color9 uppercase line`}
										text={`difficulty`}
									/>

									<Text
										tag={`p`}
										className={`p p4 notoSans-regular primary-color9 banner-item-text`}
										text={difficulty}
									/>
								</div>
							) : (
								''
							)}

							{occasion ? (
								<div className={`banner-item`}>
									<Text
										tag={`p`}
										className={`p p4 notoSans-regular primary-color9 uppercase line`}
										text={`occasion`}
									/>

									<Text
										tag={`p`}
										className={`p p4 notoSans-regular primary-color9  banner-item-text`}
										text={occasion}
									/>
								</div>
							) : (
								''
							)}

							{glass ? (
								<div className={`banner-item`}>
									<Text
										tag={`p`}
										className={`p p4 notoSans-regular primary-color9 uppercase line`}
										text={`glass`}
									/>

									<Text
										tag={`p`}
										className={`p p4 notoSans-regular primary-color9  banner-item-text`}
										text={glass}
									/>
								</div>
							) : (
								''
							)}

							<div className={`banner-item`}>
								<Text
									tag={`p`}
									className={`p p4 notoSans-regular primary-color9 uppercase line`}
									text={`garnish`}
								/>

								<Text
									tag={`p`}
									className={`p p4 notoSans-regular primary-color9  banner-item-text`}
									text={garnish || '-'}
								/>
							</div>
						</div>

						{ingredients && ingredients.length > 0 && (
							<div className={`cocktail-ingredients`}>
								<Text
									tag={`p`}
									className={`p p1 minion3-medium primary-color9 uppercase`}
									text={'ingredients'}
								/>

								<div className={`cocktail-ingredients-info`}>
									<div className={`first-field`}>
										{ingredients.map((item, index) => (
											<div
												key={index}
												className={`field-item`}
											>
												<Text
													tag={`p`}
													className={`p p4 notoSans-regular primary-color9`}
													text={item.text}
												/>
											</div>
										))}
									</div>

									<div className={`second-field`}>
										{ingredients.map((item, index) => (
											<div
												key={index}
												className={`field-item`}
											>
												<Text
													tag={`p`}
													className={`p p4 notoSans-regular primary-color9`}
													text={item.second_text}
												/>
											</div>
										))}
									</div>
								</div>
							</div>
						)}

						{methods && methods.length > 0 && (
							<div className={`cocktail-method`}>
								<Text
									tag={`p`}
									className={`p p1 minion3-medium primary-color9 uppercase`}
									text={'method'}
								/>

								<div className={`cocktail-method-info`}>
									{methods.map((item, index) => (
										<div
											key={index}
											className={`cocktail-method-info-item`}
										>
											<Text
												tag={`p`}
												className={`p p5 notoSans-regular primary-color9 method-number`}
												text={index + 1}
											/>

											<Text
												tag={`p`}
												className={`p p4 notoSans-regular primary-color9 method-text`}
												text={item}
											/>
										</div>
									))}
								</div>
							</div>
						)}

						<div className={`cocktail-time-tools`}>
							{time ? (
								<div className={`cocktail-time`}>
									<Text
										tag={`p`}
										className={`p p1 minion3-medium primary-color9 uppercase`}
										text={'duration'}
									/>

									<Text
										tag={`p`}
										className={`p p4 notoSans-regular primary-color9 cocktail-time-text`}
									>
										{time}&nbsp;{translate('min')}
									</Text>
								</div>
							) : (
								''
							)}

							{tools ? (
								<div className={`cocktail-tools`}>
									<Text
										tag={`p`}
										className={`p p1 minion3-medium primary-color9 uppercase`}
										text={'tools'}
									/>

									<Text
										tag={`p`}
										className={`p p4 notoSans-regular primary-color9 cocktail-tools-text`}
										text={tools}
									/>
								</div>
							) : (
								''
							)}
						</div>
					</div>
				</div>
			</Container>
		</HeroSectionStyle>
	)
})

export default withLanguageContext(Hero, ['translate'])
